import { authSubsGet, authSubsPost } from "src/api/authSubs";
import { SUBSCRIPTION_PRODUCT_SAL125 } from "src/types/askSalah";

export type Sal125Quotation = {
  id?: number;
  duration?: number;
  price?: number;
  currency?: "USD";
  region?: string;
  selected?: string;
  isFreeTrial?: boolean;
};

export type Sal125OrderResponse = {
  id?: number;
  url?: string;
  status?: string;
  paymentMethod?: string;
};

export type FreeTrialVerificationStatus = {
  verified: boolean | null;
  status: string;
  authorizationId: string;
};

export const fetchSal125Quotations = (
  locale?: string,
): Promise<Sal125Quotation[]> =>
  authSubsGet<Sal125Quotation[]>(
    `/subscription/quotation?product=${SUBSCRIPTION_PRODUCT_SAL125}`,
    locale,
  );

export const createSal125Order = (
  data: {
    quotationId?: number;
    paymentMethod?: string;
    proveUrl?: string;
    nationalityProofUrl?: string;
    gateway?: "tap" | "myfatoorah";
  },
  locale?: string,
): Promise<Sal125OrderResponse> =>
  authSubsPost<Sal125OrderResponse>(
    "/subscription/order",
    { ...data, product: SUBSCRIPTION_PRODUCT_SAL125 },
    locale,
  );

export const repurchaseSal125Order = (
  data?: { gateway?: "tap" | "myfatoorah" },
  locale?: string,
): Promise<Sal125OrderResponse> =>
  authSubsPost<Sal125OrderResponse>(
    `/subscription/order/repurchase?product=${SUBSCRIPTION_PRODUCT_SAL125}`,
    data ?? {},
    locale,
  );

export const verifyFreeTrialCard = (
  gateway: "tap" | "myfatoorah",
  locale?: string,
): Promise<{
  redirectUrl?: string;
  authorizationId?: string;
  gateway?: "tap" | "myfatoorah";
}> =>
  authSubsPost("/subscription/free-trial/verify-card", {
    gateway,
    product: SUBSCRIPTION_PRODUCT_SAL125,
  }, locale);

export const cancelFreeTrialVerification = (
  authorizationId: string,
  locale?: string,
): Promise<unknown> =>
  authSubsPost("/subscription/free-trial/cancel-verification", {
    authorizationId,
  }, locale);

export const getFreeTrialVerifyStatus = (
  authorizationId: string,
  locale?: string,
): Promise<FreeTrialVerificationStatus> =>
  authSubsGet<FreeTrialVerificationStatus>(
    `/subscription/free-trial/verify-status?authorizationId=${encodeURIComponent(
      authorizationId,
    )}&product=${SUBSCRIPTION_PRODUCT_SAL125}`,
    locale,
  );

export const activateFreeTrial = (
  authorizationId: string,
  locale?: string,
): Promise<{ success: boolean; message?: string }> =>
  authSubsPost("/subscription/free-trial", {
    authorizationId,
    product: SUBSCRIPTION_PRODUCT_SAL125,
  }, locale);

export const fetchAuthUserMe = (locale?: string) =>
  authSubsGet("/user/me", locale);
